/**
 * @module state.user
 * @property {String} role User role.
 * @property {Array} routes Array of parsed routes.
 * @property {Boolean} isCompanyAdmin True if is companyAdmin.
 * @property {Boolean} isSuperAdmin True if user is superAdmin.
 */
const getDefaultState = () => ({
  role: null,
  routes: [],
  isCompanyAdmin: false,
  isSuperAdmin: false,
  isSelfcareAdmin: false,
  userSinisters: [],
  isReduxMode: false,
  isMixEnabled: false
})

export {
  getDefaultState
}
